import MainLayout from "@/components/layout/MainLayout";
import ChatInterface from "@/components/assistant/ChatInterface";

const Assistant = () => {
  return (
    <MainLayout>
      <div className="travel-container py-12">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold mb-2">AI Travel Assistant</h1>
          <p className="text-gray-600 max-w-2xl mx-auto mb-2">
            Chat with our AI assistant to get personalized travel advice, destination recommendations, and help planning your trip.
          </p>
          <p className="font-bold text-gray-800 max-w-2xl mx-auto">
            Begin by typing: Plan a trip from [Source City] to [Destination City] on [Specific Date].
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <ChatInterface />
        </div>
        
        <div className="mt-8 bg-gray-50 rounded-lg p-6 max-w-4xl mx-auto">
          <h3 className="font-medium text-lg mb-3">What can I ask the AI?</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h4 className="font-medium text-travel-blue mb-2">Destination Planning</h4>
              <ul className="space-y-1 text-sm text-gray-700">
                <li>• "Where should I go for a beach vacation in December?"</li>
                <li>• "What are the best places to visit in Japan during spring?"</li>
                <li>• "I have 5 days in Rome, what should I see?"</li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-travel-blue mb-2">Travel Tips</h4>
              <ul className="space-y-1 text-sm text-gray-700">
                <li>• "What should I pack for Thailand in rainy season?"</li>
                <li>• "Is it safe to travel to Morocco as a solo female?"</li>
                <li>• "What vaccinations do I need for a trip to Kenya?"</li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-travel-blue mb-2">Budget & Planning</h4>
              <ul className="space-y-1 text-sm text-gray-700">
                <li>• "How much should I budget for a week in Paris?"</li>
                <li>• "What's the cheapest time to fly to Bali?"</li>
                <li>• "Help me plan a luxury honeymoon in the Maldives"</li>
              </ul>
            </div>
            <div>
              <h4 className="font-medium text-travel-blue mb-2">Cultural Insights</h4>
              <ul className="space-y-1 text-sm text-gray-700">
                <li>• "What are some cultural taboos in India?"</li>
                <li>• "What languages are spoken in Switzerland?"</li>
                <li>• "What's the tipping etiquette in Japan?"</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Assistant;
